<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-truck'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifferenceEnabled]="false"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
></app-kpi-widget>